import type { ProductCardDrawerTableColumns } from './types'

export const columnTitleMap: Record<keyof ProductCardDrawerTableColumns, string> = {
  name: 'Наименование',
  barcodes: 'Штрих-код',
  actions: 'Действия'
}
